<template>

  <div>
    <div class="bannerWrap">
      <my-header> </my-header>
    </div>
    <div class="mainWrap"
         v-if="showproductlist">
      <div class="main"
           v-if="Mclass==true">
        <div class="breadCrumbs">
          <h3>{{productname}} <span v-if="ifold==1">该产品仅供参考，不可购买！ </span></h3>
          <span>
            <a>首页</a> &gt;
            <router-link to="/MixedCellSeries">
              <a>产品</a> &gt;
            </router-link>
            <em>{{productname}}</em>
          </span>
        </div>
        <!--内容开始-->
        <div class="content">
          <div class="product">
            <div id="spanDiv">
              <dl v-for="(item,index) in productList.slice(0,showpage)"
                  :key="index"
                  :class="index%2 == 0 ? '' : 'cur'"
                  v-show='item.is_new!=1'>
                <!-- index<nummore&& -->
                <!--	<dl v-for="productList in productList" >-->
                <dt>
                  <img :src="httpurl+item.image"
                       width="490"
                       height="459" />
                </dt>
                <dd>
                  <p class="crXinghao">{{item.title}} </p>
                  <h3>{{item.name}}</h3>
                  <p class="desc">{{item.detail}}</p>
                  <!-- <span>￥{{item.price| toFixed(2)}} </span> -->
                  <span class="zks"><em v-if="ukey!=0">会员价:</em>￥{{item.price*zk| toFixed(2)}}
                    <s v-if="ukey!=0"
                       class="zks"> ￥{{item.price| toFixed(2)}}</s>
                  </span>
                  <div class="bt">
                    <a @click="Fusion(item)"
                       data-pid="63"
                       class="cur linkBuy"
                       v-if="ifold!=1">立即购买</a>
                    <a @click="More(item)">了解更多</a>
                  </div>
                </dd>
                <div class="clearfix"></div>
              </dl>

            </div>
            <div class="product_bottom"
                 v-if=" showpage<this.productList.length"
                 @click="lookmore()">
              <a id="linkGengDuo">
                <span class="icon"></span>
                <i>{{pagename}}</i>
              </a>
            </div>
            <div class="product_bottom">
              <a v-if=" showpage>this.productList.length||showpage==this.productList.length">
                <i>无更多产品</i>
              </a>
            </div>
          </div>

        </div>
        <!--内容结束-->
      </div>

      <div class="pro-classlist"
           v-if="Mclass==false">
        
       
        <div class="pro-classlist-name">
          <ul>
            <li v-for="(item,index) in childenMemu"
                :key="index"
                :class="item.id==productindex? 'cur' : ''"
                @click="classNamebtn(item,index)">
              <a> {{item.name}} </a>
            </li>
          </ul>
        </div>
        <div class="pro-classlist-list">
          <div class="classlist clear-fix">
            <ul class="clear-fix">
              <li class="fl"
                  v-for="(item,index) in productList.slice(0,showpage)"
                  :key="index"
                  v-show='item.is_new!=1'
                  @click="todetail()">
                <div class="classlistbox"
                     @click="More(item)">
                  <div class="img">
                    <span :style="'background-image: url('+httpurl+item.image+')'"></span>
                  </div>
                  <div class="txt">{{item.name}}</div>
                </div>
              </li>
            </ul>
            <div class="more"  v-if=" showpage<this.productList.length"  @click="lookmore()" >{{pagename}}</div>
            <!-- <div class="null">
                <a v-if="this.showpage>this.productList.length||this.showpage==this.productList.length">
                <i>无更多产品</i>
              </a>
            </div> -->
          </div>
        </div>
       
        <!-- </div> -->
      </div>

    </div>
  </div>

</template>
<script>
import { mapActions, mapGetters } from "vuex";
import myHeader from '@/views/headerimg'
import { getproduct, gzkxx } from '@/api/api'
export default {
  components: { myHeader },
  data () {
    return {
      ifold: 0,
      pagename: '查看更多 +',
      productindex: '',
      showpage: 8,
      shownomore: false,
      showmore: true,
      nummore: 8,
      lookmoreshow: false,
      productids: '',
      list: "",
      httpurl: "http://shop.qdc.com/",
      imglist: {},
      daohang: false, //显示导航
      productList: '',
      productname: "",
      showproductlist: false,
      ukey: 0,
      zhprice: '',
      zk: 1,
      screenWidth: document.body.clientWidth, // 屏幕尺寸
      Mclass: true,

    };
  },

  computed: {

    childenMemu: {
      get: function () {
        return this.$store.state.tabbarList[1].childenMemu
      },
      set: function () {
      }
    },


  },

  created () {

    window.screenWidth = document.body.clientWidth;
    this.daohang = window.screenWidth > 1024 ? true : false;
    this.Mclass = window.screenWidth > 991 ? true : false;
    this.getproductchildlist();
  },
  watch: {
    "$route": "getproductchildlist"
  },
  mounted () {
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        console.log(window.screenWidth);
        this.daohang = window.screenWidth > 1024 ? true : false;
      })();
    };
  },
  methods: {
    //折扣价
    gzkxxList () {

      if (localStorage.getItem('newukey') == '' || localStorage.getItem('newukey') == null) {
        this.ukey = 0
      } else {
        this.ukey = localStorage.getItem('newukey')
      }
      var para = {
        token: sessionStorage.getItem('token'),
        ukey: this.ukey,
      };
      gzkxx(para).then(res => {
        if (res.data.error_code == 200) {
          if (this.ukey == 0) {
            this.zhprice = this.productList.price
          } else {
            this.zk = res.data.zk
            // this.zhprice = res.data.zk * parseInt(this.productList.price)
            localStorage.setItem('discount', res.data.zk)
          }

          //   console.log("折扣价成功", res.data);

        } else {
          //   console.info("调用失败", res);
        }
      }).catch(err => {
        //   console.info("调用失败", err); 
      })
    },
    getproductchildlist () {
      if (this.productList.length < 8) {
        this.showpage = 8
      }
      if (this.$route.query.productindex == undefined) {
        this.productindex = 68
      } else {
        this.productindex = this.$route.query.productindex
      }
      var para = {
        id: this.productindex
      };
      getproduct(para).then(res => {
        if (res.data.error_code == 200) {
          //   console.log('have:' + res.data.productList)
          this.productList = res.data.productList.list
          this.productname = res.data.productList.name
          this.ifold = res.data.productList.is_old
          this.showproductlist = true
          this.gzkxxList();

        } else {
          // console.info( res.data.msg, err);
          this.getproductchildlist()
        }
      }).catch(err => { console.info("调用失败", err); })
    },
    //    getproductchildlist () {
    //        if(this.$route.query.productindex==undefined){
    //            var self = this;
    //            var para = {
    //         id: this.$route.query.productindex,

    //       };
    //       getproduct(para).then(res => {
    //         if (res.data.error_code == 200) {
    //        console.log("getproductList", res.data.productList);
    //     this.productList= res.data.productList.list
    //      this.productname= res.data.productList.name
    //         this.showproductlist=true
    //         } else {
    //           console.info("请求失败", err);
    //         }
    //       }).catch(err => { console.info("调用失败", err); })
    //        }else{
    //     getproduct(para).then(res => {
    //           if (res.data.error_code == 200) {
    //               console.log('res'+res)
    //      this.productList=res.data.productList[1].list
    //   this.productname=res.data.productList[1].name
    //       this.showproductlist=true  
    //           } else {
    //           console.info("请求失败", err);
    //         }
    //         }).catch(err => { console.info("调用失败", err); })
    //        } 
    //     },
    //            getproductchildlist(){
    //                if(this.$route.query.productindex!==undefined){
    // var self = this;

    //       var para = {
    //         id: this.$route.query.productindex,

    //       };
    //       console.log(para);

    //       getproduct(para).then(res => {
    //        console.log("getproductList", res.data.productList);
    //     this.productList= res.data.productList.list
    //      this.productname= res.data.productList.name
    //         this.showproductlist=true
    //         res => {
    //           console.info("调用失败", res);
    //         };
    //       });
    //                }else{
    //                    getproduct(para).then(res => {
    //      this.productList=res.data.productList[1].list
    //   this.productname=res.data.productList[1].name
    //       this.showproductlist=true  
    //         res => {
    //           console.info("调用失败", res);
    //         };
    //       });
    //                }

    // },

    //通过点击按钮显示移动端导航
    showdao () {
      this.daohang = !this.daohang;
    },
    //跳转产品页面
    Toproduct () {
      this.$router.push("/");
      if (window.screenWidth < 1024) {
        this.daohang = !this.daohang;
      }
    },

    //下一步
    Fusion (item) {

      if (item.iscolor == 1) {
        this.$router.push({
          path: '/PurchaseFusion',
          query: {
            childid: item.id,
            ukey: this.ukey,
            discount: this.$Base64.encode(this.zk)
          }

        });
        localStorage.setItem('discount', this.zk)
        //  this.$router.push({ path: "/PurchaseFusion" });
      }
      else {

        if (this.ukey == 0) {
          var id = this.$route.query.productindex
          localStorage.setItem('discount', '1')
          alert('请先登录')
          window.location.href = 'http://shop.qdc.com/member/login.html?lx=1&fl=1&productindex=' + id
          //  var url = 'http://shop.qdc.com/member/login.html?lx=1&fl=1&proid='+id
          //  console.log(url)
        } else {
          //  this.$router.push({ path: "/OderCenter" });
          this.$router.push({
            path: '/OderCenter',
            query: {
              ukey: this.ukey
            }

          });
        }

        this.$store.dispatch("ChangeYwwLagre", item);
        this.$store.dispatch("ChangePnumber", 1);
        this.$store.dispatch("ChangeAllsum", item.price);

      }
      // console.log('color:'+item.iscolor)
      //   console.log('this.productList.id,' + item.id)
      this.$store.dispatch("ChangeProductlist", item);

    },
    More (item) {

      this.$router.push({
        path: '/MixedCellSeriesMore',
        query: {
          childid: item.id,
          more:"a",
        }

      });
      this.$store.dispatch("ChangeProductlist", item);
       localStorage.setItem('discount', this.zk)
    },
    lookmore () {
      this.showpage += 8;
      console.log("this.showpage:"+this.showpage)
    },
    classNamebtn (item, index) {
      this.$router.push({
        path: '/MixedCellSeries',
        query: {
          productindex: item.id,
        }

      });
    }
  }
};
</script>

<style scoped>
@import "../../static/newlayout.css";
/*清除浮动*/
/*.clear{clear:both;}
.clear-fix:after {content: ".";display: block;height: 0;clear: both;visibility: hidden;}
.clear-fix {*height:1%;*zoom:1;}*/
.clear-fix:before,.clear-fix:after{content:"";display:table;}
.clear-fix:after{clear:both;}
/*IE/7/6*/
.clear-fix{*zoom:1;}
.pro-classlist {
  width: 100%;
  position: relative;
  background: #f5f5f5;
  height: 540px;
}
.pro-classlist-name {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100px;
  background: #fff;
}
.pro-classlist-name li {
  width: 100%;
  font-size: 14px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: #f4f4f4 solid 1px;
}
.pro-classlist-name li a {
  color: #333;
}
.pro-classlist-name li:last-child {
  border-bottom: none;
}
.pro-classlist-name .cur {
  border-left: #2da0f7 solid 2px;
}
.pro-classlist-name .cur a {
  color: #2da0f7;
}
.pro-classlist-list {
  width: calc(100% - 100px);
  margin-left: 100px;
  padding-left: 15px;
  overflow-y: auto;
  height: 100%;
  padding-top: 10px;
  padding-bottom: 40px;
}

.pro-classlist-list .title {
  font-size: 14px;
  color: #424242;
  line-height: 30px;
}
.pro-classlist-list .title .text2 {
  font-size: 12px;
  color: #8f8f8f;
}
.pro-classlist-list .classlist ul {
  width: 100%;
  margin: 0 -5px;
  height: 100%;
}
.pro-classlist-list .classlist li {
  width: 50%;
  padding: 0 5px;
  margin-bottom: 10px;
  border-radius: 10px;
}
.pro-classlist-list .classlistbox {
  width: 100%;
  padding: 10px;
  text-align: center;
  background: #fff;
}
.pro-classlist-list .classlistbox .img {
  width: 100%;
  height: 120px;
}
.pro-classlist-list .classlistbox .img span {
  width: 100%;
  height: 100%;
  display: block;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.pro-classlist-list .classlistbox .txt {
  color: #5c5c5c;
  font-size: 14px;
  line-height: 28px;
  border-top: 1px solid #ededed;
  height: 28px;
 overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
}
.bottomboxs /deep/ .footerheight {
  margin-top: 0;
}
.more,.null{font-size: 14px;color: #000;text-align: center;background: #2da0f7;color: #fff}
.more{background: #2da0f7;color: #fff;width: 100px;height: 34px;line-height: 34px;text-align: center;margin: 0 auto;border-radius: 5px;}
@media screen and (max-width:480px) {
    .pro-classlist-list .classlistbox .txt{font-size: 12px;line-height: 24px;height: 24px;}
}
</style>


// WEBPACK FOOTER //
// src/views/MixedCellSeries.vue